import React, { useEffect } from "react";
import moment from "moment";
import { useSnakbar } from "../../../../../../Context/Context-Snakbar/ContextSnackbar";
import NumberFormat from "react-number-format";
import CreatableSelect from "react-select/creatable";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import AddBoxIcon from "@material-ui/icons/AddBox";
import { v4 as uuidv4 } from "uuid";
import { addImage, subtractImage } from "../../../../../../assets";
function EndMove(props) {
  const { showErrorSnak } = useSnakbar();
  const {
    cash_payment_rate,
    card_payment_rate,
    rate_method,
    cash_min_flat_rate,
    cash_max_flat_rate,
    card_min_flat_rate,
    card_max_flat_rate,
  } = props.requestData.request;
  const {
    endTime,
    setEndTime,
    MakeSecondDocument,
    net_distance,
    request_type,
    calculateRemainingAmount,
    calculateRemainingTime,
    extraItemsList,
    extraItems,
    setExtraItems,
    calculateFinalAmount,
    handleChangeInAdditionalSplit,
  } = props;

  const getOptions = (limit) => {
    let options = [];
    for (let i = 0; i <= limit; i++) {
      options.push(i);
    }
    return options;
  };

  const getMinutesOptions = () => {
    let options = [0, 15, 30, 45];
    return options;
  };

  const handleClick = () => {
    // if (
    //   parseInt(endTime.drive_time.hours) === 0 &&
    //   parseInt(endTime.drive_time.minutes) === 0 &&
    //   net_distance > 10
    // ) {
    //   showErrorSnak("Please enter your drive time.");
    //   return;
    // }
    if (endTime.move_time.hours === 0 && endTime.move_time.minutes === 0) {
      showErrorSnak("Please enter your move time.");
      return;
    }
    // if (endTime.break_time.hours === 0 && endTime.break_time.minutes === 0) {
    //   showErrorSnak("Please enter your break time.");
    //   return;
    // }

    if (rate_method === "Flat") {
      const total = calculateFinalAmount();
      if (!Number(total)) {
        showErrorSnak("Please enter your final amount.");
        return;
      }
    }

    MakeSecondDocument();
  };

  const handleChange = (newValue, actionMeta, local_id) => {
    console.group("Value Changed");
    console.log(newValue);
    console.log(`action: ${actionMeta.action}`);
    console.groupEnd();
    if (actionMeta.action === "clear") {
      handleChangeInExtraItem(local_id, {
        item: {},
        price: "",
        custom: false,
        quantity: "",
      });
    }
    if (actionMeta.action === "create-option") {
      handleChangeInExtraItem(local_id, {
        item: newValue,
        price: 0,
        custom: true,
        quantity: "1",
      });
    }

    if (actionMeta.action === "select-option") {
      handleChangeInExtraItem(local_id, {
        item: newValue,
        price: newValue.unit_price,
        custom: false,
        quantity: "1",
      });
    }
  };
  const handleInputChange = (inputValue, actionMeta) => {
    console.group("Input Changed");
    console.log(inputValue);
    console.log(`action: ${actionMeta.action}`);
    console.groupEnd();
  };

  const handleAddExtraItem = () => {
    setExtraItems((c) => [
      ...c,
      { local_id: uuidv4(), quantity: "", item: "", price: "", custom: false },
    ]);
  };

  const handleRemoveExtraItem = (local_id) => {
    console.log(local_id, "local_id");
    console.log(extraItems, "extraItems");
    const list = extraItems.filter((item) => item.local_id !== local_id);
    setExtraItems(list);
  };

  const handleChangeInExtraItem = (local_id, updated) => {
    const list = extraItems.map((item) => {
      if (item.local_id === local_id) {
        return { ...item, ...updated };
      } else {
        return item;
      }
    });

    setExtraItems(list);
  };

  const additionalItemsCost = () => {
    let total = 0;
    const list = extraItems.map((item) => {
      if (item.item && item.price) {
        total = total + Number(item.price) * Number(item.quantity);
      }
    });
    return total;
  };

  const additionalDiscountAmount = () => {
    let discount = Number(endTime.discount_amount);
    discount = discount ? discount : 0;
    return discount;
  };

  useEffect(() => {
    // this code is responsible to remove arrow from react-select component
    // It runs every time we add or remove extra item form list.
    if (extraItems.length > 0) {
      const elements = document.getElementsByClassName("remove-arrow-using-js");
      if (elements) {
        for (let i = 0; i < elements.length; i++) {
          const element = elements[i].children[1].firstElementChild.children[1];
          if (element) {
            element.remove();
          }
        }
      }
    }
  }, [extraItems.length]);

  return (
    <>
      <div
        className="modal fade"
        id="start-move"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="start-move-title"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content pb-30">
            <div className="modal-header text-center border-0 pb-0">
              <button
                type="button"
                className="close black-color"
                data-dismiss="modal"
                aria-label="Close"
                id="end-move-close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="form-wrapper pl-4 pr-4 pl-sm-5 pr-sm-5">
              <div className="modal-body p-0">
                <h5 className="text-center" id="start-move-title">
                  End Move
                </h5>
                <p className="pt-3 text-center">Enter work time</p>

                {/* {net_distance > 10 && ( */}
                <div className="end-move-box">
                  <div className="row">
                    <div className="col-12">
                      <p className="pt-1 sub-title mb-1">Double Drive Time</p>
                    </div>
                  </div>
                  <div className="row ">
                    <div className="col-6">
                      <div className="form-group">
                        <label
                          htmlFor="start-time"
                          className="overline dark-grey-color"
                        >
                          Select Hour(s)
                        </label>

                        <select
                          required
                          value={endTime.drive_time.hours}
                          onChange={(e) =>
                            setEndTime({
                              ...endTime,
                              drive_time: {
                                ...endTime.drive_time,
                                hours: e.target.value,
                              },
                            })
                          }
                          name=""
                          className="custom-select custom-select-lg custom-select-sm form-control form-control-sm small-font-size"
                        >
                          {getOptions(100).map((val) => (
                            <option key={val} value={val}>
                              {val} {val > 1 ? "hours" : "hour"}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group">
                        <label
                          htmlFor="start-time"
                          className="overline dark-grey-color"
                        >
                          Select Minute(s)
                        </label>

                        <select
                          required
                          value={endTime.drive_time.minutes}
                          onChange={(e) =>
                            setEndTime({
                              ...endTime,
                              drive_time: {
                                ...endTime.drive_time,
                                minutes: e.target.value,
                              },
                            })
                          }
                          name=""
                          className="custom-select custom-select-lg custom-select-sm form-control form-control-sm small-font-size"
                        >
                          {getMinutesOptions().map((val) => (
                            <option key={val} value={val}>
                              {val} {val > 1 ? "minutes" : "minute"}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                {/* )} */}

                <div className="end-move-box">
                  <div className="row">
                    <div className="col-12">
                      <p className="pt-1 sub-title mb-1">Move Time</p>
                    </div>
                  </div>
                  <div className="row ">
                    <div className="col-6">
                      <div className="form-group">
                        <label
                          htmlFor="start-time"
                          className="overline dark-grey-color"
                        >
                          Select Hour(s)
                        </label>

                        <select
                          required
                          value={endTime.move_time.hours}
                          onChange={(e) => {
                            setEndTime({
                              ...endTime,
                              move_time: {
                                ...endTime.move_time,
                                hours: e.target.value,
                              },
                            });
                          }}
                          name=""
                          className="custom-select custom-select-lg custom-select-sm form-control form-control-sm small-font-size"
                        >
                          {getOptions(100).map((val) => (
                            <option key={val} value={val}>
                              {val} {val > 1 ? "hours" : "hour"}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group">
                        <label
                          htmlFor="start-time"
                          className="overline dark-grey-color"
                        >
                          Select Minute(s)
                        </label>

                        <select
                          required
                          value={endTime.move_time.minutes}
                          onChange={(e) =>
                            setEndTime({
                              ...endTime,
                              move_time: {
                                ...endTime.move_time,
                                minutes: e.target.value,
                              },
                            })
                          }
                          name=""
                          className="custom-select custom-select-lg custom-select-sm form-control form-control-sm small-font-size"
                        >
                          {getMinutesOptions().map((val) => (
                            <option key={val} value={val}>
                              {val} {val > 1 ? "minutes" : "minute"}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="end-move-box">
                  <div className="row">
                    <div className="col-12">
                      <p className="pt-1 sub-title mb-1">Break Time</p>
                    </div>
                  </div>
                  <div className="row ">
                    <div className="col-6">
                      <div className="form-group">
                        <label
                          htmlFor="start-time"
                          className="overline dark-grey-color"
                        >
                          Select Hour(s)
                        </label>

                        <select
                          required
                          value={endTime.break_time.hours}
                          onChange={(e) =>
                            setEndTime({
                              ...endTime,
                              break_time: {
                                ...endTime.break_time,
                                hours: e.target.value,
                              },
                            })
                          }
                          name=""
                          className="custom-select custom-select-lg custom-select-sm form-control form-control-sm small-font-size"
                        >
                          {getOptions(100).map((val) => (
                            <option key={val} value={val}>
                              {val} {val > 1 ? "hours" : "hour"}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group">
                        <label
                          htmlFor="start-time"
                          className="overline dark-grey-color"
                        >
                          Select Minute(s)
                        </label>

                        <select
                          required
                          value={endTime.break_time.minutes}
                          onChange={(e) =>
                            setEndTime({
                              ...endTime,
                              break_time: {
                                ...endTime.break_time,
                                minutes: e.target.value,
                              },
                            })
                          }
                          name=""
                          className="custom-select custom-select-lg custom-select-sm form-control form-control-sm small-font-size"
                        >
                          {getMinutesOptions().map((val) => (
                            <option key={val} value={val}>
                              {val} {val > 1 ? "minutes" : "minute"}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                {request_type && (
                  <div className="end-move-box border-top border-bottom pt-3 pb-3">
                    <div className="row">
                      <div className="col-12">
                        <p className="pt-1 sub-title mb-1">Additional Items</p>
                      </div>
                    </div>
                    {extraItems.length === 0 && (
                      <label
                        htmlFor="start-time"
                        className="overline dark-grey-color"
                      >
                        No Additional item here
                      </label>
                    )}
                    {extraItems.map((item) => (
                      <div className="row ">
                        <div className="col-5 col-lg-6">
                          <div className="form-group remove-arrow-using-js">
                            <label
                              htmlFor="start-time"
                              className="overline dark-grey-color"
                            >
                              Item Name
                            </label>

                            <CreatableSelect
                              isClearable
                              value={item.item}
                              onChange={(value, action) =>
                                handleChange(value, action, item.local_id)
                              }
                              onInputChange={handleInputChange}
                              options={extraItemsList}
                              placeholder="Type here..."
                            />
                          </div>
                        </div>

                        <div className="col-3 col-lg-2">
                          <div className="form-group">
                            <label
                              htmlFor="start-time"
                              className="overline dark-grey-color"
                            >
                              Qty
                            </label>
                            <NumberFormat
                              style={{ height: 38 }}
                              allowNegative={false}
                              allowLeadingZeros
                              value={item.quantity}
                              onChange={(e) =>
                                handleChangeInExtraItem(item.local_id, {
                                  quantity: e.target.value,
                                })
                              }
                              required
                              allowedDecimalSeparators={false}
                              type="text"
                              className="form-control small-font-size"
                              placeholder="1"
                              autoComplete="off"
                              disabled={!item.item.label}
                            />
                          </div>
                        </div>
                        <div className="col-3 col-lg-3">
                          <div className="form-group">
                            <label
                              htmlFor="start-time"
                              className="overline dark-grey-color"
                            >
                              Price
                            </label>
                            <NumberFormat
                              style={{ height: 38 }}
                              allowNegative={false}
                              allowLeadingZeros
                              value={item.price}
                              onChange={(e) =>
                                handleChangeInExtraItem(item.local_id, {
                                  price: e.target.value,
                                })
                              }
                              required
                              type="text"
                              className="form-control small-font-size"
                              placeholder="100"
                              autoComplete="off"
                              disabled={!item.item.label}
                            />
                          </div>
                        </div>
                        <div className="col-1 p-0 pb-1 text-right ">
                          <RemoveCircleOutlineIcon
                            onClick={() => handleRemoveExtraItem(item.local_id)}
                            className="end-move-action pointer-point"
                          />
                        </div>
                      </div>
                    ))}
                    <div className="col-12 p-0 pb-1 text-right ">
                      <AddCircleOutlineIcon
                        onClick={handleAddExtraItem}
                        className="pointer-point"
                      />
                    </div>
                  </div>
                )}
                {request_type &&
                  (endTime.move_time.hours !== 0 ||
                    endTime.move_time.minutes !== 0) && (
                    <>
                      <div className="end-move-box ">
                        <div className="row">
                          <div className="col-12 mt-3">
                            <p className="pt-1 sub-title mb-1">
                              Payment Details
                              {rate_method === "Flat" &&
                                endTime.payment_method === "Cash" && (
                                  <span className="float-right dark-grey-color">
                                    ( ${cash_min_flat_rate} - $
                                    {cash_max_flat_rate})
                                  </span>
                                )}
                              {rate_method === "Flat" &&
                                endTime.payment_method === "Card" && (
                                  <span className="float-right dark-grey-color">
                                    ( ${card_min_flat_rate} - $
                                    {card_max_flat_rate})
                                  </span>
                                )}
                            </p>
                          </div>
                        </div>
                        <div className="row ">
                          <div className="col-6">
                            <div className="form-group">
                              <label
                                htmlFor="start-time"
                                className="overline dark-grey-color"
                              >
                                Payment Method
                              </label>

                              <select
                                required
                                value={endTime.payment_method}
                                onChange={(e) => {
                                  setEndTime({
                                    ...endTime,
                                    payment_method: e.target.value,
                                  });
                                }}
                                name=""
                                className="custom-select custom-select-lg custom-select-sm form-control form-control-sm small-font-size"
                              >
                                <option value="Cash">Cash</option>
                                <option value="Card">Card</option>
                                <option value="Both (Card and Cash)">
                                  Both (Card and Cash)
                                </option>
                              </select>
                            </div>
                          </div>
                          {rate_method === "Flat" && (
                            <>
                              {endTime.payment_method === "Cash" && (
                                <div className="col-6">
                                  <div className="form-group">
                                    <label
                                      htmlFor="start-time"
                                      className="overline dark-grey-color"
                                    >
                                      Cash Amount
                                    </label>

                                    <NumberFormat
                                      allowNegative={false}
                                      allowLeadingZeros
                                      value={endTime.cash_amount}
                                      required
                                      type="text"
                                      className="form-control small-font-size"
                                      placeholder="100"
                                      autoComplete="off"
                                      onChange={(e) => {
                                        setEndTime({
                                          ...endTime,
                                          cash_amount: e.target.value,
                                        });
                                      }}
                                      // disabled
                                    />
                                  </div>
                                </div>
                              )}
                              {endTime.payment_method === "Card" && (
                                <div className="col-6">
                                  <div className="form-group">
                                    <label
                                      htmlFor="start-time"
                                      className="overline dark-grey-color"
                                    >
                                      Card Amount
                                    </label>

                                    <NumberFormat
                                      allowNegative={false}
                                      allowLeadingZeros
                                      value={endTime.card_amount}
                                      required
                                      type="text"
                                      className="form-control small-font-size"
                                      placeholder="100"
                                      autoComplete="off"
                                      onChange={(e) => {
                                        setEndTime({
                                          ...endTime,
                                          card_amount: e.target.value,
                                        });
                                      }}
                                    />
                                  </div>
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                      {request_type &&
                        (endTime.payment_method === "Card" ||
                          endTime.payment_method === "Cash") && (
                          <div className="row border-top">
                            <div className="col-12">
                              <p className="pt-1 sub-title mb-1">
                                Additional Discount
                              </p>
                            </div>

                            <div className="col-12">
                              <div className="form-group">
                                <label
                                  htmlFor="start-time"
                                  className="overline dark-grey-color"
                                >
                                  Discount Amount
                                </label>

                                <NumberFormat
                                  allowNegative={false}
                                  allowLeadingZeros
                                  value={endTime.discount_amount}
                                  required
                                  type="text"
                                  className="form-control small-font-size"
                                  placeholder="$"
                                  autoComplete="off"
                                  onChange={(e) => {
                                    setEndTime({
                                      ...endTime,
                                      discount_amount: e.target.value,
                                    });
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        )}

                      {(endTime.payment_method === "Card" ||
                        endTime.payment_method === "Cash") && (
                        <div className="row border-top mt-2">
                          <div className="col-12 mt-3">
                            <p className="pt-1 sub-title mb-1">Cost Details</p>
                          </div>
                          <div className="col-6">Moving Cost:</div>{" "}
                          <div className="col-6">${calculateFinalAmount()}</div>
                          <div className="col-6">Additional Cost:</div>{" "}
                          <div className="col-6">${additionalItemsCost()}</div>{" "}
                          <div className="col-6">Additional Discount:</div>{" "}
                          <div className="col-6 light-red-color">
                            ${additionalDiscountAmount()}
                          </div>
                          <div className="col-6">Grand Total:</div>{" "}
                          <div className="col-6">
                            <b>
                              {" "}
                              $
                              {calculateFinalAmount() +
                                additionalItemsCost() -
                                additionalDiscountAmount()}
                            </b>
                          </div>
                        </div>
                      )}
                      {endTime.payment_method === "Both (Card and Cash)" && (
                        <>
                          {rate_method === "Hourly" && (
                            <>
                              {/* Time split */}
                              {/* Cash time */}
                              <div className="end-move-box  pt-2">
                                <div className="row">
                                  <div className="col-12">
                                    <p className="pt-1 sub-title mb-1">
                                      Time On Cash
                                      <span className="float-right dark-grey-color">
                                        (${cash_payment_rate}/hour)
                                      </span>
                                    </p>
                                  </div>
                                </div>
                                <div className="row ">
                                  <div className="col-6">
                                    <div className="form-group">
                                      <label
                                        htmlFor="start-time"
                                        className="overline dark-grey-color"
                                      >
                                        Select Hour(s)
                                      </label>

                                      <select
                                        required
                                        value={endTime.cash_time.hours}
                                        onChange={(e) =>
                                          calculateRemainingTime(
                                            "Cash",
                                            "HH",
                                            e.target.value
                                          )
                                        }
                                        name=""
                                        className="custom-select custom-select-lg custom-select-sm form-control form-control-sm small-font-size"
                                      >
                                        {getOptions(
                                          Number(endTime.move_time.hours) +
                                            Number(endTime.drive_time.hours)
                                        ).map((val) => (
                                          <option key={val} value={val}>
                                            {val} {val > 1 ? "hours" : "hour"}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                  <div className="col-6">
                                    <div className="form-group">
                                      <label
                                        htmlFor="start-time"
                                        className="overline dark-grey-color"
                                      >
                                        Select Minute(s)
                                      </label>

                                      <select
                                        required
                                        value={endTime.cash_time.minutes}
                                        onChange={(e) =>
                                          calculateRemainingTime(
                                            "Cash",
                                            "MM",
                                            e.target.value
                                          )
                                        }
                                        name=""
                                        className="custom-select custom-select-lg custom-select-sm form-control form-control-sm small-font-size"
                                      >
                                        {getMinutesOptions().map((val) => (
                                          <option key={val} value={val}>
                                            {val}{" "}
                                            {val > 1 ? "minutes" : "minute"}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/* card time */}
                              <div className="end-move-box">
                                <div className="row">
                                  <div className="col-12">
                                    <p className="pt-1 sub-title mb-1">
                                      Time On Card
                                      <span className="float-right dark-grey-color">
                                        (${card_payment_rate}/hour)
                                      </span>
                                    </p>
                                  </div>
                                </div>
                                <div className="row ">
                                  <div className="col-6">
                                    <div className="form-group">
                                      <label
                                        htmlFor="start-time"
                                        className="overline dark-grey-color"
                                      >
                                        Select Hour(s)
                                      </label>

                                      <select
                                        required
                                        value={endTime.card_time.hours}
                                        onChange={(e) =>
                                          calculateRemainingTime(
                                            "Card",
                                            "HH",
                                            e.target.value
                                          )
                                        }
                                        name=""
                                        className="custom-select custom-select-lg custom-select-sm form-control form-control-sm small-font-size"
                                      >
                                        {getOptions(
                                          Number(endTime.move_time.hours) +
                                            Number(endTime.drive_time.hours)
                                        ).map((val) => (
                                          <option key={val} value={val}>
                                            {val} {val > 1 ? "hours" : "hour"}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                  <div className="col-6">
                                    <div className="form-group">
                                      <label
                                        htmlFor="start-time"
                                        className="overline dark-grey-color"
                                      >
                                        Select Minute(s)
                                      </label>

                                      <select
                                        required
                                        value={endTime.card_time.minutes}
                                        onChange={(e) =>
                                          calculateRemainingTime(
                                            "Card",
                                            "MM",
                                            e.target.value
                                          )
                                        }
                                        name=""
                                        className="custom-select custom-select-lg custom-select-sm form-control form-control-sm small-font-size"
                                      >
                                        {getMinutesOptions().map((val) => (
                                          <option key={val} value={val}>
                                            {val}{" "}
                                            {val > 1 ? "minutes" : "minute"}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}

                          {/* Flat rate split */}
                          {rate_method === "Flat" && (
                            <div className="end-move-box">
                              <div className="row">
                                <div className="col-12">
                                  <p className="pt-1 sub-title mb-1">
                                    Move Amount Split Payment
                                  </p>
                                </div>
                              </div>
                              <div className="row ">
                                <div className="col-6">
                                  <div className="form-group">
                                    <label
                                      htmlFor="start-time"
                                      className="overline dark-grey-color"
                                    >
                                      Cash Amount
                                    </label>

                                    <NumberFormat
                                      allowNegative={false}
                                      allowLeadingZeros
                                      value={endTime.cash_amount}
                                      required
                                      type="text"
                                      className="form-control small-font-size"
                                      placeholder="100"
                                      autoComplete="off"
                                      onChange={(e) => {
                                        setEndTime({
                                          ...endTime,
                                          cash_amount: e.target.value,
                                        });
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="col-6">
                                  <div className="form-group">
                                    <label
                                      htmlFor="start-time"
                                      className="overline dark-grey-color"
                                    >
                                      Card Amount
                                    </label>

                                    <NumberFormat
                                      allowNegative={false}
                                      allowLeadingZeros
                                      value={endTime.card_amount}
                                      required
                                      type="text"
                                      className="form-control small-font-size"
                                      placeholder="100"
                                      autoComplete="off"
                                      onChange={(e) => {
                                        setEndTime({
                                          ...endTime,
                                          card_amount: e.target.value,
                                        });
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {/* Additional Item Price split */}

                          <div className="end-move-box">
                            {extraItems.length > 0 && (
                              <>
                                <div className="row">
                                  <div className="col-12">
                                    <p className="pt-1 sub-title mb-1">
                                      Additional Amount Split Payment
                                    </p>
                                  </div>
                                </div>
                                <div className="row ">
                                  <div className="col-6">
                                    <div className="form-group">
                                      <label
                                        htmlFor="start-time"
                                        className="overline dark-grey-color"
                                      >
                                        Cash Amount
                                      </label>

                                      <NumberFormat
                                        allowNegative={false}
                                        allowLeadingZeros
                                        value={endTime.additional_cash_amount}
                                        onChange={(e) =>
                                          handleChangeInAdditionalSplit(
                                            "cash",
                                            Number(e.target.value)
                                          )
                                        }
                                        required
                                        type="text"
                                        className="form-control small-font-size"
                                        placeholder="100"
                                        autoComplete="off"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-6">
                                    <div className="form-group">
                                      <label
                                        htmlFor="start-time"
                                        className="overline dark-grey-color"
                                      >
                                        Card Amount
                                      </label>

                                      <NumberFormat
                                        allowNegative={false}
                                        allowLeadingZeros
                                        value={endTime.additional_card_amount}
                                        onChange={(e) =>
                                          handleChangeInAdditionalSplit(
                                            "card",
                                            Number(e.target.value)
                                          )
                                        }
                                        required
                                        type="text"
                                        className="form-control small-font-size"
                                        placeholder="100"
                                        autoComplete="off"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}

                            {request_type && (
                              <div className="row border-top border-bottom pt-2">
                                <div className="col-12">
                                  <p className="pt-1 sub-title mb-1">
                                    Additional Discount
                                  </p>
                                </div>

                                <div className="col-12">
                                  <div className="form-group">
                                    <label
                                      htmlFor="start-time"
                                      className="overline dark-grey-color"
                                    >
                                      Discount Amount
                                    </label>

                                    <NumberFormat
                                      allowNegative={false}
                                      allowLeadingZeros
                                      value={endTime.discount_amount}
                                      required
                                      type="text"
                                      className="form-control small-font-size"
                                      placeholder="$"
                                      autoComplete="off"
                                      onChange={(e) => {
                                        setEndTime({
                                          ...endTime,
                                          discount_amount: e.target.value,
                                        });
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}

                            <div className="row">
                              <div className="col-12 mt-1">
                                <p className="pt-1 sub-title mb-1">
                                  Split Details
                                </p>
                              </div>
                              <div className="col-6">Cash Amount:</div>{" "}
                              <div className="col-6">
                                $
                                {Number(endTime.cash_amount) +
                                  Number(endTime.additional_cash_amount)}
                                {` (${Number(endTime.cash_amount)}+${Number(
                                  endTime.additional_cash_amount
                                )})`}
                              </div>
                              <div className="col-6">Card Amount:</div>{" "}
                              <div className="col-6">
                                $
                                {Number(endTime.card_amount) +
                                  Number(endTime.additional_card_amount)}
                                {` (${Number(endTime.card_amount)}+${Number(
                                  endTime.additional_card_amount
                                )})`}
                              </div>
                            </div>
                            <div className="row form-group row border-top mt-2">
                              <div className="col-12 mt-3">
                                <p className="pt-1 sub-title mb-1">
                                  Cost Details
                                </p>
                              </div>
                              <div className="col-6">Moving Cost:</div>{" "}
                              <div className="col-6">
                                ${calculateFinalAmount()}
                              </div>
                              <div className="col-6">Additional Cost:</div>{" "}
                              <div className="col-6">
                                ${additionalItemsCost()}
                              </div>
                              <div className="col-6">Additional Discount:</div>{" "}
                              <div className="col-6 light-red-color">
                                ${additionalDiscountAmount()}
                              </div>
                              <div className="col-6">Grand Total:</div>{" "}
                              <div className="col-6">
                                <b>
                                  $
                                  {calculateFinalAmount() +
                                    additionalItemsCost() -
                                    additionalDiscountAmount()}
                                </b>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  )}
                <div className="buttons-wrapper pt-2">
                  <div className="row pt-1 pb-3">
                    <div className="col-12">
                      <button
                        onClick={handleClick}
                        className="custom-buton custom-buton-large w-100"
                      >
                        Go For Agreement
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EndMove;
